import { useEffect } from "react";
import {React, useState } from "react";
import ReactQuill from "react-quill";
import { t } from "../../Helper";
import { useSelector } from "react-redux";

const PagesInfo = ({ onChange, selectedPages }) => {

  const [homePageContent, setHomePageContent] = useState("Landing Page Content");
  const [aboutUsPageContent, setAboutUsPageContent] = useState("About Us Page Content");
  const [contactUsPageContent, setContactUsPageContent] = useState("Contact Us Page Content");

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          homePageContent,
          currentLanguage,
          preferredLanguage
        );
        setHomePageContent(fetchedData);

        const fetchedData2 = await t(
          aboutUsPageContent,
          currentLanguage,
          preferredLanguage
        );
        setAboutUsPageContent(fetchedData2);

        const fetchedData3 = await t(
          contactUsPageContent,
          currentLanguage,
          preferredLanguage
        );
        setContactUsPageContent(fetchedData3);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);
  
  var modules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
      ],
      [
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
            "custom-color",
          ],
        },
      ],
    ],
  };

  var formats = [
    "header",
    "height",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "color",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "size",
  ];

  const [pagesData, setPagesData] = useState({
    home: "",
    about: "",
    contact: "",
  });

  const handleProcedureContentChange = (content, page) => {
    if (page == "home") {
      pagesData.home = content;
    }

    if (page == "about-us") {
      pagesData.about = content;
    }

    if (page == "contact") {
      pagesData.contact = content;
    }

    setPagesData(pagesData);
    onChange(pagesData);
  };

  return (
    <>
      {selectedPages.includes("Home") && (
        <div className="col-12">
          <label className="form-label section-title">{homePageContent}</label>
          <div id="editorLanding">
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              placeholder="Write your content..."
              onChange={(content) =>
                handleProcedureContentChange(content, "home")
              }
              style={{ marginBottom: "50px" }}
            />
          </div>
        </div>
      )}

      {selectedPages.includes("About") && (
        <div className="col-12">
          <label className="form-label section-title">{aboutUsPageContent}</label>
          <div id="editorLanding">
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              placeholder="Write your content..."
              onChange={(e) => handleProcedureContentChange(e, "about-us")}
              style={{ marginBottom: "50px" }}
            />
          </div>
        </div>
      )}

      {selectedPages.includes("Contact") && (
        <div className="col-12">
          <label className="form-label section-title">{contactUsPageContent}</label>
          <div id="editorLanding">
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              placeholder="Write your content..."
              onChange={(e) => handleProcedureContentChange(e, "contact")}
              style={{ marginBottom: "50px" }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PagesInfo;
